import produce from 'immer'
import { assign } from 'lodash'

import {
  FETCH_DIET,
  SET_DIET_PAGE_TO_DIRTY,
  UPDATE_DIET_EXCLUDED_ALLERGENS_DETAILS,
  UPDATE_DIET_EXCLUDED_INGREDIENTS_DETAILS,
  UPDATE_DIET_IMAGE_DETAILS,
  UPDATE_DIET_SIMPLE_DETAILS,
} from '../action-types'
import { DIET_INITIAL_STATE } from '../initial-states'

const dietReducer = (state = DIET_INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_DIET_PAGE_TO_DIRTY:
      return produce(state, nextState => assign(nextState, action.payload))
    case FETCH_DIET.START:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLoading: true,
          fetchError: undefined,
          data: [],
        }),
      )

    case FETCH_DIET.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLoading: false,
          fetchError: undefined,
          data: action.payload.data.diet,
        }),
      )

    case FETCH_DIET.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLoading: false,
          fetchError: action.error.message,
          data: [],
        }),
      )

    case FETCH_DIET.CLEANUP:
      return { ...DIET_INITIAL_STATE }

    case UPDATE_DIET_SIMPLE_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isSimpleDetailsLoading: true,
          simpleDetailsError: undefined,
        }),
      )

    case UPDATE_DIET_SIMPLE_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isSimpleDetailsLoading: false,
          simpleDetailsError: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateDietSimpleDetails,
          ),
          isDirty: false,
        }),
      )

    case UPDATE_DIET_SIMPLE_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isSimpleDetailsLoading: false,
          simpleDetailsError: action.error.message,
        }),
      )

    case UPDATE_DIET_IMAGE_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isImageDetailsLoading: true,
          imageDetailsError: undefined,
        }),
      )

    case UPDATE_DIET_IMAGE_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isImageDetailsLoading: false,
          imageDetailsError: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateDietImageDetails,
          ),
        }),
      )

    case UPDATE_DIET_IMAGE_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isImageDetailsLoading: false,
          imageDetailsError: action.error.message,
        }),
      )

    case UPDATE_DIET_EXCLUDED_ALLERGENS_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isExcludedAllergensDetailsLoading: true,
          excludedAllergensDetailsError: undefined,
        }),
      )

    case UPDATE_DIET_EXCLUDED_ALLERGENS_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isExcludedAllergensDetailsLoading: false,
          excludedAllergensDetailsError: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateDietExcludedAllergensDetails,
          ),
        }),
      )

    case UPDATE_DIET_EXCLUDED_ALLERGENS_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isExcludedAllergensDetailsLoading: false,
          excludedAllergensDetailsError: action.error.message,
        }),
      )

    case UPDATE_DIET_EXCLUDED_INGREDIENTS_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isExcludedIngredientsDetailsLoading: true,
          excludedIngredientsDetailsError: undefined,
        }),
      )

    case UPDATE_DIET_EXCLUDED_INGREDIENTS_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isExcludedIngredientsDetailsLoading: false,
          excludedIngredientsDetailsError: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateDietExcludedIngredientsDetails,
          ),
        }),
      )

    case UPDATE_DIET_EXCLUDED_INGREDIENTS_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isExcludedIngredientsDetailsLoading: false,
          excludedIngredientsDetailsError: action.error.message,
        }),
      )

    default:
      return state
  }
}

export default dietReducer
